var _circle, _circle2, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.565,
    cy: 15.925,
    r: 12,
    fill: "#313d53",
    transform: "matrix(1.33863 0 0 1.3331 -4.726 -5.217)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#313D53"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#CAF3E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.507 9.447a.75.75 0 0 1 .046 1.06l-11 12a.75.75 0 0 1-1.083.023l-5-5a.75.75 0 1 1 1.06-1.06l4.446 4.446L51.447 9.493a.75.75 0 0 1 1.06-.046",
    fill: "#3CA377"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.629 4.457c-1.047.044-2.314.695-3.064 1.568-.675.776-1.264 2.014-1.104 3.202 1.167.091 2.357-.59 3.085-1.465.726-.874 1.217-2.09 1.083-3.305m-.296 20.666c1.418-.027 2.316-1.28 3.184-2.541.951-1.382 1.37-2.722 1.433-2.922l.008-.023-.005-.001c-.137-.056-2.76-1.117-2.787-4.183-.025-2.532 2.005-3.792 2.229-3.93l.016-.011c-1.222-1.777-3.125-2.021-3.803-2.049-.991-.1-1.952.277-2.738.584-.498.196-.926.364-1.246.364-.355 0-.795-.173-1.288-.368-.646-.255-1.384-.547-2.146-.532-1.765.025-3.393 1.021-4.302 2.593-1.835 3.168-.471 7.86 1.317 10.428.876 1.255 1.916 2.668 3.284 2.618.612-.026 1.047-.209 1.497-.399.519-.221 1.058-.449 1.912-.449.814 0 1.33.221 1.825.435.473.204.928.399 1.61.386",
    fill: "#313d53",
    style: {
      display: "inline",
      fill: "#fff",
      strokeWidth: 0.776119
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessApple);
export default __webpack_public_path__ + "static/media/successApple.fbe526cefc6115286ec5eb2e6953572e.svg";
export { ForwardRef as ReactComponent };